import React, { useEffect, useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import CrossGrayIcon from '../../common/images-new/cross-gray-icon.svg'
import ButtonBlue from "../../components/Button/ButtonBlue";
import NavTabs from "../../components/Navbar/NavTabs";
import { staticFiles } from "../../components/Helpers/Static";
import SharePostCardExport from "../../pages/Community/SharePostCardExport";
import { emptyList } from "../../redux/actions/sharePost";
import { getMyPosts, getShowcases } from "../../redux/actions/showcase";
import ShowcaseOption from "./ShowcaseOption";

import axios from "axios";
import { apiMainUrl, serverUrl } from "../Helpers/Config";
import { Card } from "../../pages/Theme";
import {
  exportPostHTML,
  exportPostPDF,
  exportShowcaseHTML,
  exportShowcasePDF,
} from "../../redux/actions/export";
import ButtonHashtag from "../Button/ButtonHashtag";
import Swal from "sweetalert2";
import {
  BgPostButton,
  ModalInActive,
  ButtonCommonTopNew,
  ButtonCommonTopGrey,
} from "../../pages/Theme";
import { FaSearch } from "react-icons/fa";
import { AiOutlineRight } from "react-icons/ai";
const CROSS_GRAY_ICON = staticFiles.cross;

const ModalExport = ({ show, setShow }) => {
  const dispatch = useDispatch();
  const userProfile = useSelector((state) => state.auth.user);
  const showcases = useSelector((state) => state.showcase.showcases);
  const myPosts = useSelector((state) => state.showcase.myPosts);
  const isLoading = useSelector((state) => state.export.isLoading);
  const [initialLoad, setinitialLoad] = useState(false);
  const [checkedList, setCheckedList] = useState([]);
  const [checkedListPost, setCheckedListPost] = useState([]);
  const [selectedShowcase, setSelectedShowcase] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [textFilter, setTextFilter] = useState("");
  const [filteredPosts, setFilteredPosts] = useState([]);
  const [showJournal, setShowJournal] = useState(false);
  const [showShowcase, setShowcase] = useState(true);

  const profile = {
    name: userProfile ? userProfile.fullname : "",
    email: userProfile ? userProfile.email : "",
    programme: userProfile ? userProfile.programme : "",
    photo: userProfile ? userProfile.photo : "",
    cover: userProfile ? userProfile.cover : "",
  };

  const showHideModal = show
    ? "fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 block modelIndex"
    : "fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 hidden";

  const tabs = [
    { text: "Showcase", id: 1 },
    { text: "Journal", id: 2 },
  ];

  useEffect(() => {
    dispatch(getShowcases());
    dispatch(getMyPosts());
    setShowcase(true);
    setShowJournal(false);
  }, []);

  useEffect(() => {
    setShowcase(true);
    setShowJournal(false);
  }, [show]);

  useEffect(() => {
    if (myPosts?.length > 0 && initialLoad == false) {
      setCheckedListPost(myPosts);
      setinitialLoad(true);
    }
    const filteredData = myPosts.filter((postItem) =>
      postItem.reflection_title.toLowerCase().includes(textFilter.toLowerCase())
    );
    setFilteredPosts(filteredData);
  }, [textFilter, myPosts]);

  function close() {
    setShow(false);
    setCurrentPage(1);
    setCheckedList([]);
    setCheckedListPost(myPosts);
  }

  function switchTab(id) {
    setCurrentPage(id);
    // setCheckedList([])
  }

  // Add and remove function for post list
  function addPost(id) {
    const newList = [
      ...checkedListPost,
      ...myPosts.filter((item) => item.reflection_id === id),
    ];

    setCheckedListPost(newList);
  }

  function removePost(id) {
    const newList = checkedListPost.filter((item) => item.reflection_id !== id);
    setCheckedListPost(newList);
  }

  // Add and remove function for showcase list
  function addShowcase(id) {
    const newList = [
      ...checkedList,
      ...showcases.filter((item) => item.id === id),
    ];

    setCheckedList(newList);
  }

  function removeShowcase(id) {
    const newList = checkedList.filter((item) => item.id !== id);
    setCheckedList(newList);
  }

  const handleExportPdf = () => {
    if (checkedList.length !== 0 || checkedListPost.length != 0) {
      dispatch(exportShowcasePDF(checkedList, checkedListPost));
    } else {
      Swal.fire({
        heightAuto: false,
        title: "Warning",
        text: "Please choose atleast one Showcase or Journal",
        icon: "error",
      });
    }
  };

  const handleExportHtml = () => {
    if (checkedList.length !== 0) {
      if (currentPage === 1) {
        dispatch(exportShowcaseHTML(checkedList));
      } else if (currentPage === 2) {
        dispatch(exportPostHTML(checkedList));
      }
    }
  };

  const selectAllNone = () => {
    if (
      checkedListPost?.length == filteredPosts?.length &&
      checkedListPost?.length > 0
    ) {
      setCheckedListPost([]);
    }
    if (
      checkedListPost?.length > 0 &&
      checkedListPost?.length != filteredPosts?.length
    ) {
      setCheckedListPost(filteredPosts);
    }
    if (checkedListPost?.length == 0 && filteredPosts?.length > 0) {
      setCheckedListPost(filteredPosts);
    }
  };

  const Showed = ({ active, text, length }) => {
    let style = active ? "rotate-90" : "rotate-0";
    style += " transform";
    return (
      <div className="w-full flex items-center my-3">
        <div
          className="flex pr-3 cursor-pointer"
          onClick={() => {
            if (text === "Showcase") {
              setShowcase(!showShowcase);
              setShowJournal(false);
            } else if (text === "Journal") {
              setShowJournal(!showJournal);
              setShowcase(false);
            }
          }}
        >
          <div className="w-max flex items-center">
            <AiOutlineRight className={style} /> {text} ({length})
          </div>
        </div>
        <div className="w-full border h-0" />
      </div>
    );
  };
  return (
    <div className={showHideModal} onClick={(e) => e.stopPropagation()}>
      <div className="fixed inset-0 modelIndex flex items-center justify-center bg-black bg-opacity-50 px-4 py-6">
        <div
          className={`relative cardBackgroundColor rounded-xl shadow-md p-4 max-w-full max-h-screen overflow-auto top-2 bottom-2 right-2 left-2 modal-popup-extra-width`}
        >
          <div className="flex gap-2 items-center justify-between">
            <p className="font-semibold blackColor">Export</p>
            <button
              onClick={close}
              className="text-gray-600 hover:text-black text-xl font-bold"
            >
              &times;
            </button>
          </div>
          <div className="w-full mb-6">
            <NavTabs
              menuLinks={[
                {
                  title: "Showcase",
                  index: "showcase",
                  onChange: (e) => {
                    setShowcase(true);
                    setShowJournal(false);
                  },
                },
                {
                  title: "Journal",
                  index: "Journal",
                  onChange: (e) => {
                    setShowcase(false);
                    setShowJournal(true);
                  },
                },
              ]}
              value={showShowcase ? "showcase" : "Journal"}
              padding={false}
              isDot={false}
            />
          </div>
          <div className="">
            {/* <Showed
              active={showShowcase}
              text={"Showcase"}
              length={
                showcases?.filter((r) => r?.posts?.length > 0)?.length || 0
              }
            /> */}
            {showShowcase ? (
              <div>
                <div className="flex flex-wrap gap-5">
                  {showcases?.filter((r) => r?.posts?.length > 0)?.length !==
                    0 &&
                    showcases.map((showcase, index) =>
                      showcase?.posts?.length > 0 ? (
                        <ShowcaseOption
                          key={index}
                          showcase={showcase}
                          add={addShowcase}
                          remove={removeShowcase}
                          isShow={checkedList.filter(
                            (r) => r.id == showcase.id
                          )}
                        />
                      ) : (
                        ""
                      )
                    )}
                  {showcases?.filter((r) => r?.posts?.length > 0)?.length ===
                    0 && (
                    <div className="text-center font-bold">
                      No showcases found
                    </div>
                  )}
                </div>
              </div>
            ) : null}
            {/* <Showed
              active={showJournal}
              text={"Journal"}
              length={filteredPosts.length}
            /> */}
            {showJournal ? (
              <div>
                <div className="flex flex-col">
                  <div className="flex flex-wrap gap-2 justify-between mb-2">
                    <div className="flex flex-row items-center relative">
                      {/* <label className="text-sm mr-5 whitespace-nowrap font-bold">Search post</label> */}
                      <input
                        className="h-9 w-40 text-sm bg-white borderf-1 px-2 pr-9 lg:pr-9 blackColor rounded-md"
                        type="search"
                        placeholder="Type to Search..."
                        onChange={(e) => setTextFilter(e.target.value)}
                        value={textFilter}
                      />
                      <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none">
                        <FaSearch className="secondaryIcon" />
                      </div>
                    </div>
                    {filteredPosts?.length > 0 && (
                      <div
                        className="cursor-pointer items-end justify-end relative pt-2"
                        onClick={selectAllNone}
                      >
                        <ButtonCommonTopNew className="select-allnone px-5 border p-2 text-sm rounded-lg cursor-pointer hover:opacity-80">
                          {checkedListPost?.length > 0 &&
                          checkedListPost?.length == filteredPosts?.length
                            ? "Unselect All"
                            : "Select All"}
                        </ButtonCommonTopNew>
                      </div>
                    )}
                  </div>
                  <div className="flex flex-col max-h-72 space-y-3 py-5 overflow-y-auto">
                    {filteredPosts?.length !== 0 &&
                      filteredPosts.map((post, index) => (
                        <SharePostCardExport
                          key={index}
                          idx={index}
                          item={post}
                          add={addPost}
                          remove={removePost}
                          isShow={checkedListPost.filter(
                            (r) => r.reflection_id == post.reflection_id
                          )}
                        />
                      ))}
                    {filteredPosts.length === 0 && (
                      <div className="text-center font-bold text-sm lightColor">
                        No posts found
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) : null}
          </div>
          <div className="flex flex-row items-center pt-2 justify-center">
            <>
              <ButtonCommonTopNew
                title=""
                className={`px-5 border p-2 text-sm rounded-lg ${
                  isLoading ? "pointer-events-none" : "cursor-pointer"
                } `}
                onClick={() => {
                  handleExportPdf();
                }}
              >
                {isLoading ? "Loading..." : "Export as PDF"}
              </ButtonCommonTopNew>
              {/* <ButtonBlue 
                                    title='EXPORT AS HTML' 
                                    onClick={() => {
                                        handleExportHtml();
                                    }}
                                
                                /> */}
            </>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalExport;

//  <div className="cursor-pointer flex flex-row items-center justify-center pt-2 gap-3">
//                         {tabs.map((tab, ind) => (
//                             currentPage === tab.id ?
//                                 <ButtonCommonTopNew
//                                     key={tab.id}
//                                     className={`px-5 border p-2 font-bold text-sm cursor-pointer rounded-full-tab hover:opacity-80`}
//                                     onClick={() => switchTab(tab.id)}
//                                 >
//                                     {tab.text}
//                                 </ButtonCommonTopNew> :
//                                 <ButtonCommonTopGrey
//                                     key={tab.id}
//                                     className={`px-5 border p-2 font-bold text-sm cursor-pointer rounded-full-tab hover:opacity-80`}
//                                     onClick={() => switchTab(tab.id)}
//                                 >
//                                     {tab.text}
//                                 </ButtonCommonTopGrey>
//                         ))}
//                     </div>
//                     <div className="overflow-x-auto pt-2">
//                         {currentPage === 1 && (
//                             <div className="flex flex-col ">
//                                 <div className='flex flex-col space-y-3 py-4 overflow-y-auto'>

//                                 </div>
//                             </div>
//                         )}
//                         {currentPage === 2 && (
//                             <div className="flex flex-col">
//                                 <div className='flex flex-wrap gap-2 justify-between'>
//                                     <div className='flex flex-row mb-2 items-center mt-2 relative'>
//                                         {/* <label className="text-sm mr-5 whitespace-nowrap font-bold">Search post</label> */}
//                                         <input
//                                             className='h-10 w-full bg-white borderf-1 px-2 pr-9 lg:pr-9 blackColor rounded-md'
//                                             type='search'
//                                             placeholder='Type to Search...'
//                                             onChange={(e) => setTextFilter(e.target.value)}
//                                             value={textFilter}
//                                         />
//                                         <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none">
//                                             <FaSearch className="w-5 h-5 secondaryIcon" />
//                                         </div>
//                                     </div>
//                                     {filteredPosts?.length > 0 &&
//                                         <div className='cursor-pointer items-end justify-end relative pt-2' onClick={selectAllNone}>
//                                             <ButtonCommonTopNew className='select-allnone px-5 border p-2 font-bold text-sm rounded-lg cursor-pointer hover:opacity-80'>{(checkedListPost?.length > 0 && checkedListPost?.length == filteredPosts?.length) ? "Unselect All" : "Select All"}</ButtonCommonTopNew>
//                                         </div>
//                                     }
//                                 </div>
//                                 <div className='flex flex-col max-h-56 space-y-3 py-5 overflow-y-auto'>
//                                     {filteredPosts?.length !== 0 && filteredPosts.map((post, index) => (
//                                         <SharePostCardExport
//                                             key={index}
//                                             idx={index}
//                                             item={post}
//                                             add={addPost}
//                                             remove={removePost}
//                                             isShow={checkedListPost.filter((r) => r.reflection_id == post.reflection_id)}
//                                         />
//                                     ))}
//                                     {filteredPosts.length === 0 &&
//                                         <div className='text-center font-bold'>No posts found</div>
//                                     }
//                                 </div>
//                             </div>
//                         )}
//                     </div>
